import React from 'react'
import './Card.css'
import { themeContext } from '../../Context'
import { useContext } from 'react'

function Card({emoji,heading,detalis}) {
  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode
  return (
    <div className="card" >
        <img src={emoji}   alt="" />
        <span style={{color:darkMode? 'black' : ''}}>{heading}</span>
        <span style={{alignItems:'center',textAlign:'center'}} >{detalis}</span>
        <button className='button c-btn' >Learn More</button>
    </div>
  )
}

export default Card